/* global Swiper */

document.querySelectorAll( '.b-featured-articles' ).forEach( ( block ) => {

	const blockSwiper = block.querySelector( '.b-featured-articles .swiper' );

	if ( ! blockSwiper ) {

		return;

	}

	const inner = block.querySelector( '.b-featured-articles__inner' );
	const slidesPerView = parseInt( inner?.dataset.slidesPerView, 10 ) || 3;
	const totalItems = parseInt( inner?.dataset.totalItems, 10 ) || 0;

	const paginationEl = block.querySelector( '.b-featured-articles__swiper-pagination' );
	const prevEl = block.querySelector( '.b-featured-articles__button-prev' );
	const nextEl = block.querySelector( '.b-featured-articles__button-next' );

	new Swiper( blockSwiper, {
		spaceBetween: 16,
		slidesPerView: 1,
		loop: totalItems > slidesPerView,
		slideClass: 'articles-item',
		navigation: {
			nextEl: nextEl,
			prevEl: prevEl,
		},
		pagination: {
			el: paginationEl,
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: slidesPerView,
			},
		},
	} );

} );
